/* eslint-disable import/prefer-default-export */

export const dateFormat = 'MM/DD/YYYY';
export const timeFormat = 'hh:mm A';
export const timeWithSecondsFormat = 'hh:mm:ss A';
export const dateTimeFormat = 'MM/DD/YYYY hh:mm A';
export const newInputDateFormat = 'MM/dd/yyyy';
export const newInputDateTimeFormat = 'MM/dd/yyyy h:mm aa';
export const inputDateFormat = 'm/d/Y';
export const inputDateTimeFormat = 'm/d/Y h:i K';
export const workOrderFilterDateFormat = 'YYYY-MM-DD';
export const workOrderCreatedAtDateFormat = 'D-MMM-YYYY';
export const workOrderServiceDateFormat = 'Do MMM, YYYY';
export const dayMonthDateYearTimeFormat = 'LLLL';
export const monthDateYearTimeFormat = 'LLL';
export const dayOfTheDate = 'dddd';
export const dateYearFormat = 'LL';
export const expiryAndExtensionDateFormat = 'MM-DD-YYYY';
export const dateWithMonthNameFormat = 'DD MMMM YYYY';
